/**
 * Colors of the figures, read from the --fx-* CSS variables of fourier_style.css so they follow the light / dark theme.
 */
const NAMES = ["surface", "ink", "ink-muted", "grid", "faint", "x", "y"];
const listeners = [];
let cache = null;

export function colors() {
  if (cache === null) {
    const style = getComputedStyle(document.body);
    cache = {};
    for (const name of NAMES) {
      cache[name] = style.getPropertyValue("--fx-" + name).trim();
    }
  }
  return cache;
}

export function onThemeChange(listener) {
  listeners.push(listener);
}

//The theme toggle of base.html switches the dark-mode class of the body.
new MutationObserver(() => {
  cache = null;
  for (const listener of listeners) {
    listener();
  }
}).observe(document.body, { attributes: true, attributeFilter: ["class"] });
